module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundærlogo_sentrert_neg.343e3f53.png";